import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

export default function KeywordsFilter({ values, filter }) {
  const { state, setKeywords } = useAllFilterBaseContext();
  const { keywords, industries } = state;

  const [allSkills, setAllSkills] = useState([]);

  useEffect(() => {
    if (values) {
      setAllSkills(values);
    }
  }, [values]);

  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    const updatedSkills = [...keywords, newLanguage];
    setKeywords(updatedSkills);
  };

  const handleDeleteLanguage = (id) => {
    const updatedLanguages = keywords.filter((language) => language.id !== id);
    setKeywords(updatedLanguages);
  };
  return (
    <div>
      <ReactSelect
        options={
          Array.isArray(allSkills) && Array.isArray(industries)
            ? allSkills
              .filter((category) => {
                // Check if category's parent_id exists in industries array
                return (
                  industries.some(
                    (industry) => industry.id === category.parent_id
                  ) &&
                  // Keep the original filter for excluding already selected keywords
                  (!Array.isArray(keywords) ||
                    !keywords.some(
                      (selectedLang) => selectedLang.id === category.id
                    ))
                );
              })
              .map((category) => ({
                value: category.id,
                label: category.title,
              }))
            : []
        }
        placeholder={`Select ${filter.title}`}
        isClearable={true}
        value={[]}
        onChange={(options) => {
          if (options) {
            handleLanguageChange(options);
          }
        }}
      />

      <div className="add-skills">
        {Array.isArray(keywords) &&
          keywords.map((skills, index) => (
            <div key={index}>
              <p onClick={() => handleDeleteLanguage(skills.id)}>
                {skills.title} <span>x</span>
              </p>
            </div>
          ))}
      </div>
    </div>
  );
}
